import React from 'react'
import ReactDOM from 'react-dom'
import 'utils/patchDomForTranslators'
import './i18n'
import App from './App'
import * as Sentry from '@sentry/react'
import { ThemeProvider } from '@material-ui/styles'

import UnexpectedError from 'views/UnexpectedError'

import { getSentryDsn, getBaseURL } from 'service/env'
import { dponet } from 'service'
import theme from 'theme'

const getAuthDetails = () => {
  try {
    return {
      userId: dponet.auth.isAuthenticated()
        ? dponet.auth.getUserIdFromToken()
        : undefined,
      companyId: dponet.auth.getCompany() || undefined,
    }
  } catch {
    return {}
  }
}

const isProd = process.env.REACT_APP_API === 'production'

if (isProd) {
  Sentry.init({
    dsn: getSentryDsn(),
    release: `${process.env.REACT_APP_PROJECT_NAME}@${process.env.REACT_APP_GIT_VERSION}`,
    environment: process.env.REACT_APP_API,
    integrations: [
      new Sentry.BrowserTracing({
        tracePropagationTargets: [getBaseURL('website'), getBaseURL('dponet')],
      }),
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: isProd ? 1.0 : 0,
    replaysSessionSampleRate: isProd ? 0.1 : 0,
    replaysOnErrorSampleRate: isProd ? 1.0 : 0,
  })
}

ReactDOM.render(
  <Sentry.ErrorBoundary
    fallback={({ eventId }) => {
      const { userId, companyId } = getAuthDetails()

      return (
        <ThemeProvider theme={theme}>
          <UnexpectedError
            eventId={eventId}
            userId={userId}
            companyId={companyId}
            previousPage={document.referrer || undefined}
          />
        </ThemeProvider>
      )
    }}
  >
    <App />
  </Sentry.ErrorBoundary>,
  document.getElementById('root'),
)
